import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";
import { getPaymentMethodErrorCode } from "./paymentMethodError";

type Payload = {
  productId: string;
  authorId: string;
  paymentGatewayCustomerId: string;
  paymentMethodId: string;
};

type ConvertManualPaymentToCardParams = Omit<ActionParams<Payload>, "onFailure"> & {
  onFailure?: (errorCode: string) => void;
};

export const convertManualPaymentToCard = createAsyncThunk<
  void,
  ConvertManualPaymentToCardParams,
  AsyncThunkCreator<string>
>(
  `${PRODUCT_CLIENT_REDUCER}/convertManualPaymentToCard`,
  async ({ payload, onSuccess, onFailure }, { rejectWithValue, extra: { productApi, analytics } }) => {
    try {
      await productApi.post("/convert-manual-payment-to-card", payload);
      analytics.track("convert_manual_payment_to_card", {
        productId: payload.productId,
        authorId: payload.authorId,
      });
      onSuccess?.();
    } catch (e) {
      const errorCode = getPaymentMethodErrorCode(e);
      onFailure?.(errorCode);

      return rejectWithValue(errorCode);
    }
  },
);
